import React from "react";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

import TotalRevenueSalesModule from "./totalRevenueSales/index";
import ServiceSalesModule from "./serviceSales/index";
import ProductSalesModule from "./productSales/index";
import PastDueCollections from "./pastDuesCollections/index";

const pageConfig = {
  pageName: "Sales Revenue",
  configuratorWidth: 400,
  moduleList: [TotalRevenueSalesModule, ServiceSalesModule, ProductSalesModule, PastDueCollections]
};

const SalesRevenuePage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default SalesRevenuePage;
